import { fromByteArray } from 'base64-js';
import { ELanguages } from 'src/shared/enum';
import Cookies from 'js-cookie';
import {
  ImageService,
  PriceSummary2,
  SimpleMenuDefProvider,
  emptyOrderTable,
  priceMenuSet,
  priceOrder,
  updateImplicitPaymods,
  types as rs,
} from 'earn-ts';
import { ErrorCode } from 'src/reducer/order/orderThunk';

export const formatCurrency = (currency: number) => {
  var re = '\\d(?=(\\d{' + 3 + '})+' + '$' + ')';
  return currency.toFixed(Math.max(2, ~~0)).replace(new RegExp(re, 'g'), '$&,');
};

export function gentoken() {
  const bytes = new Uint8Array(16);

  (global as any).crypto.getRandomValues(bytes);
  return fromByteArray(bytes).replace(/[/=+]/g, '');
}

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const setCookie = (name: string, value: any) => {
  return Cookies.set(name, value);
};

export const formatCents = (cents: number | bigint) => {
  return formatCurrency(Number(cents) / 100.0);
};

export function pickName(
  o: { name_en: string | null; name_cn: string | null } | null,
  lang: string,
) {
  if (lang === ELanguages.EN) {
    return o?.name_en || '';
  } else {
    return o?.name_cn || '';
  }
}

export function imgService(shopId: string) {
  return new ImageService(shopId, process.env.REACT_APP_URL_IMAGE!);
}

function guessPaymods(order: rs.OrderTable, menuDef: rs.MenuDef) {
  return updateImplicitPaymods(order, menuDef, [], gentoken);
}

export type TUpdateSetPrice =
  | {
      prices: Record<string, number>;
      totalPrice: number;
      basePrice: number;
    }
  | undefined;

/**
 * Recalculates set price for all and  calculates total price.
 * So it needs to know all the sets in the order.
 */
export function updateSetPrices(
  unsentSets: rs.OrderMenuSet[],
  fullOrder: rs.OrderContainer | null,
  menuDef: rs.MenuDef,
): TUpdateSetPrice {
  let provider = new SimpleMenuDefProvider(menuDef);
  try {
    // build a potential order
    let order = {
      ...emptyOrderTable.json,
      ...(fullOrder?.table?.json ?? {}),
    };

    // merge
    let allsets = [...order.menu_items];
    unsentSets.forEach(set => {
      let index = allsets.findIndex(x => x.id == set.id);
      if (index >= 0) {
        allsets[index] = set;
      } else {
        allsets.push(set);
      }
    });
    order.menu_items = allsets;

    // price everything
    let orderTable = fullOrder?.table ?? { ...emptyOrderTable };
    orderTable.json = order;
    orderTable.base_price = priceOrder(provider, order);
    let fullOrderNew: rs.OrderContainer = {
      payments: fullOrder?.payments ?? guessPaymods(orderTable, menuDef),
      table: orderTable,
    };

    let ps2 = new PriceSummary2(
      fullOrderNew.table,
      fullOrderNew.payments,
      provider,
    );
    ps2.calc();

    let prices: Record<string, number> = {};
    allsets.map(set => (prices[set.id] = priceMenuSet(provider, set)));

    return {
      prices,
      totalPrice: ps2.total!,
      basePrice: orderTable.base_price,
    };
  } catch (err) {
    console.error('updateSetPrice', err);
  }
}

export type TranslateFn = (key: string) => string;

export const genErrorMessage = (t: TranslateFn, message?: string) => {
  const errorMessages = {
    [ErrorCode.Expired]: t('order-expired'),
    'menudef.not_available.at_this_time': t(
      'menu-is-not-available-at-this-time',
    ),
    'menudef.set.disabled': t('menu-is-currently-disabled'),
    'menudef.set.takeout_only': t('takeout-service-only'),
    'menudef.set.dinein_only': t('dine-in-service-only'),
  };

  let error = t('order-fail-message');

  if (message) {
    Object.keys(errorMessages).forEach(item => {
      if (message.includes(item.toString())) {
        error = errorMessages[item as keyof typeof errorMessages];
      }
    });
  }

  return error;
};
